import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: '#2375b7',
    secondary: '#2f3988',
    terciary: '#dcf3ff',
    accent: '#68d9ff',
    oscuro: '#374147', // color tambien definido en estilos.js
    error: '#e42323',
    info: '#68d9ff',
    success: '#22b573',
    warning: '#fbc368'
  }
})
